import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import auth from '../../../common/utility/auth';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                {row.flagAdministrador ? (
                                    <Button
                                        disabled={!auth.user().flagAdministrador}
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        onClick={() => props.onEdit(row)}
                                    />

                                ) :
                                    <Button
                                        disabled={!row.flag}
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        onClick={() => props.onEdit(row)}
                                    />
                                }

                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Eliminar" : "Activar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "delete" : "check"}
                                    size={"small"}
                                    disabled={row.flagAdministrador ? true : false}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Restablecer Contraseña"}>
                            
                                {row.flagAdministrador ? (
                                    <Button
                                        disabled={!auth.user().flagAdministrador}
                                        type="primary"
                                        icon="lock"
                                        size={"small"}
                                        onClick={() => props.onEditContrasenia(row)}
                                    />

                                ) :
                                    <Button
                                        disabled={!row.flag}
                                        type="primary"
                                        icon="lock"
                                        size={"small"}
                                        onClick={() => props.onEditContrasenia(row)}
                                    />
                                }

                            </Tooltip>
                            <Tooltip placement="top" title={"Asignar Series"}>
                       

                                {row.flagAdministrador ? (
                                    <Button
                                        disabled={!auth.user().flagAdministrador}
                                        type="primary"
                                        icon="bars"
                                        size={"small"}
                                        onClick={() => props.onAsignarSeries(row)}
                                    />

                                ) :
                                    <Button
                                        disabled={!row.flag}
                                        type="primary"
                                        icon="bars"
                                        size={"small"}
                                        onClick={() => props.onAsignarSeries(row)}
                                    />
                                }

                            </Tooltip>

          {/*                   <Tooltip placement="top" title={"Configuración"}>
                                <Button
                                    disabled={auth.user().flagAdministrador ? false : true}
                                    loading={props.loadingConfiguracion}
                                    type="primary"
                                    icon="setting"
                                    size={"small"}
                                    onClick={() => props.onAsignarPermisos(row)}
                                />
                            </Tooltip> */}
                        </div>
                    )
                },
                {
                    title: 'Usuario',
                    dataIndex: 'usuario',
                    key: 'usuario',
                    sorter: true
                },
                {
                    title: 'Rol',
                    dataIndex: 'nombreRol',
                    key: 'nombreRol',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'abreviaturaTipoDocumento',
                    key: 'abreviaturaTipoDocumento',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Apellido Paterno',
                    dataIndex: 'apellidoPaterno',
                    key: 'apellidoPaterno',
                    sorter: true
                },
                {
                    title: 'Apellido Materno',
                    dataIndex: 'apellidoMaterno',
                    key: 'apellidoMaterno',
                    sorter: true
                },
                {
                    title: 'Correo',
                    dataIndex: 'correo',
                    key: 'correo',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}